import React, { useRef, useState, useEffect } from 'react';
import { Form } from '@unform/web';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { Container, Label, TimePicker } from './styles';
import api from '~/services/api';
// Importando componentes
import Card from '~/components/Card';
import Select from '~/components/Form/Select';
import Button from '~/components/Form/Button';
import Load from '~/components/Load';

export default function Agendamento() {
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [carregar, setCarregar] = useState(false);
  const [produtoTemplate, setProdutoTemplate] = useState([]);
  const [horario, setHorario] = useState(new Date());

  useEffect(() => {
    async function getDados() {
      setLoading(true);
      const responseProduto = await api.get('/produto-select');

      const data = responseProduto.data.map(produto => {
        return {
          value: produto.id,
          label: produto.name,
        };
      });

      setProdutoTemplate(data);
      setLoading(false);
    }

    getDados();
  }, [setProdutoTemplate]);

  async function handleAgendar(data, { reset }) {
    try {
      setCarregar(true);
      inputRef.current.setErrors({});

      const schema = Yup.object().shape({
        produtos: Yup.string('Selecione o(s) produto(s)').required(
          'Selecione o(s) produto(s)'
        ),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      await api.post('/agendamento-multiplo', {
        produtos: data.produtos,
        data: horario,
      });

      toast.success('Agendamento feito com sucesso');
      reset();
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        inputRef.current.setErrors(validationErrors);
      } else {
        toast.error(
          'Error ao agendar atendimentos multiplos, verifique os dados'
        );
      }
    } finally {
      setCarregar(false);
    }
  }

  if (loading) {
    return <Load />;
  }

  return (
    <Container>
      <h4>Agendamentos multiplos</h4>
      <Card size={50}>
        <Form ref={inputRef} onSubmit={handleAgendar}>
          <Select
            options={produtoTemplate}
            labelSelect="Selecione os produtos"
            name="produtos"
            isMulti
          />
          <Label>
            <span>Escolha a nova data de agendamento</span>
            <TimePicker
              selected={horario}
              onChange={date => setHorario(date)}
              locale="pt-BR"
              minDate={new Date()}
              timeFormat="HH:mm"
              showTimeSelect
              placeholderText="Selecionar data"
              dateFormat="d/MM/yyyy HH:mm"
              es
            />
          </Label>
          <Button tamanho="40px" load={carregar}>
            Agendar
          </Button>
        </Form>
      </Card>
    </Container>
  );
}
